import React from "react";
import { Link } from "react-router-dom";
import { Col } from "reactstrap";
import { Title, PgaLogoContainer, LoginButton, PaddedDiv } from "./shared";
import pgaLogo from "../../../../assets/images/logo-dark.svg";

const ModalContentLogin = ({
  copy: { titleText, message, actionMessage, CancelComp },
  toggle,
  toggleBack,
  history,
  location,
}) => {
  return (
    <Col lg="12">
      <PaddedDiv>
        <Title>
          <PgaLogoContainer>
            <img
              src={pgaLogo}
              alt="member professional logo"
              style={{ width: "100%", height: "100%" }}
            />
          </PgaLogoContainer>
          {titleText}
        </Title>
        <div>
          {message}
          {actionMessage}
        </div>
        <CancelComp {...{ toggle, toggleBack, history }} />
        <Link to={{ pathname: "/login", state: { page: location.pathname } }}>
          <LoginButton onClick={toggle}>LOGIN</LoginButton>
        </Link>
      </PaddedDiv>
    </Col>
  );
};
export default ModalContentLogin;
